export default __webpack_public_path__ + "static/default-image-a85298180eaf8f65522c581da367a3f9.jpg";